import Layout from "@/views/layout/layout";
const rootPath = "/loans";

const loans = {
  path: rootPath,
  description: "조회",
  redirect: rootPath + "/loansAccounts",
  component: Layout,
  children: [
    {
      path: "loansAccounts",
      name: "loansIn",
      description: "대출조회",
      component: () => import("@/views/templates/loans/loansAccounts"),
      props: () => ({ inAcnKnd: "2", inAcnDtlKnd: "2" }),
      meta: {
        roles: ["login"],
        step: 1,
      },
    },
    {
      path: "interestLoanPaymentView",
      name: "interestLoanPaymentView",
      redirect: { name: "interestLoanPaymentStep1" },
      component: () => import("@/views/templates/loans/interestLoanPaymentView"),
      children: [
        {
          path: "step1",
          name: "interestLoanPaymentStep1",
          description: "이자/월부금납부-Step1",
          component: () => import("@/views/templates/loans/interestLoanPaymentStep1"),
          meta: {
            roles: ["login"],
            step: 1,
          },
        },
        {
          path: "step2",
          name: "interestLoanPaymentStep2",
          description: "이자/월부금납부-Step2",
          component: () => import("@/views/templates/loans/interestLoanPaymentStep2"),
          meta: {
            roles: ["login"],
            step: 2,
          },
        },
        {
          path: "step3",
          name: "interestLoanPaymentStep3",
          description: "이자/월부금납부-Step3",
          component: () => import("@/views/templates/loans/interestLoanPaymentStep3"),
          meta: {
            roles: ["login"],
            step: 3,
            firstPage: "interestLoanPaymentView",
          },
        },
        {
          path: "step4",
          name: "interestLoanPaymentStep4",
          description: "이자/월부금납부-Step4",
          component: () => import("@/views/templates/loans/interestLoanPaymentStep4"),
          meta: {
            roles: ["login"],
            transparent: true,
            isLast: true,
          },
        },
      ],
    },
    {
      path: "lnamtRpayAnticiInq",
      name: "lnamtRpayAnticiInq",
      redirect: { name: "lnamtRpayAnticiInqStep1" },
      component: () => import("@/views/templates/loans/lnamtRpayAnticiInq"),
      children: [
        {
          path: "step1",
          name: "lnamtRpayAnticiInqStep1",
          description: "대출금상환-Step1",
          component: () => import("@/views/templates/loans/lnamtRpayAnticiInqStep1"),
          meta: {
            roles: ["login"],
            step: 1,
          },
        },
        {
          path: "step2",
          name: "lnamtRpayAnticiInqStep2",
          description: "대출금상환-Step2",
          component: () => import("@/views/templates/loans/lnamtRpayAnticiInqStep2"),
          meta: {
            roles: ["login"],
            step: 2,
          },
        },
        {
          path: "step3",
          name: "lnamtRpayAnticiInqStep3",
          description: "대출금상환-Step3",
          component: () => import("@/views/templates/loans/lnamtRpayAnticiInqStep3"),
          meta: {
            roles: ["login"],
            step: 3,
            firstPage: "lnamtRpayAnticiInq",
          },
        },
        {
          path: "step4",
          name: "lnamtRpayAnticiInqStep4",
          description: "대출금상환-Step4",
          component: () => import("@/views/templates/loans/lnamtRpayAnticiInqStep4"),
          meta: {
            roles: ["login"],
            transparent: true,
            isLast: true,
          },
        },
      ],
    },
    {
      path: "rpayRsultInq",
      name: "rpayRsultInq",
      description: "과거 대출 내역",
      component: () => import("@/views/templates/loans/rpayRsultInq"),
      meta: {
        roles: ["login"],
      },
    },
  ],
};

export default loans;
